








import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboCampanha extends Vue {
  @Prop() itemsTipo: ComboItem | undefined;
  valid = false;
  tipo: ComboItem | null = null;

  @Watch("tipo")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.text);
  }
}
